import { eTipoPermissao } from '@/enums/ePermissoes';
export default [
    {
        description: 'Evento',
        path: '/biblioteca/bibevento',
        name: 'bibevento',
        component: () => import('@/views/biblioteca/bibevento/Index.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_EVENTONOVO_MENU_1300800999],
        },
        goesToMenu: true,
    },
    {
        description: 'Cadastro de Eventos',
        path: '/biblioteca/bibevento/cadastro/:id?',
        parent: 'bibevento',
        name: 'bibevento_create',
        component: () => import('@/views/biblioteca/bibevento/InclusaoEdicao.vue'),
        meta: {
            permissions: [eTipoPermissao.BIB_EVENTONOVO_MENU_1300800999],
        },
        goesToMenu: true,
    },
]
